import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/orders";

class OrderService {
  getOrders = async ({ page = 1, limit = 12, sortByStatus }) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/`, {
        params: {
          page,
          limit,
          sortByStatus: sortByStatus || undefined,
        },
      });

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching orders.");
    }
  };

  getOrderById = async (id) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching order by id.");
    }
  };

  createOrder = async (requestData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestData);
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating order.");
    }
  };

  updateOrderStatus = async ({ id, status }) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/${id}/status`, {
        status,
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating order status.");
    }
  };

  deleteOrder = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting order.");
    }
  };
}

const orderService = new OrderService();
export default orderService;
